import FullBoardConst from '../constants/full_board.constants';
import { getUniqueWsResults } from '../utils/function';

const FullBoardReducers = (state = {}, action) => {
  const initState = state;

  switch (action.type) {
    case FullBoardConst.FULL_BRD_FAV_ADD:
      if (action.value) {
        initState.favorites.unshift(action.value);

        state = { ...state, initState };
      }
      break;

    case FullBoardConst.FULL_BRD_FAV_DEL:
      if (action.value) {
        initState.favorites = initState.favorites.filter(item => item.obj_id != action.value);
        state = { ...state, initState };
      }
      break;

    case FullBoardConst.UPDATE_BOARD_DATA:

      if (action.value) {
        const items = initState.boardLeftmenuData.workstreams;
        const workstreamData = action.value.boardLeftmenuData.workstreams;

        const {
          teams = {}, personal = {}, retriedWS = {}, shareWs = {}
        } = workstreamData || {};

        const newTeams = teams.length > 0
          ? getUniqueWsResults(teams, items.teams) : items.teams;
        const newPersonal = Object.keys(personal).length > 0
          ? { ...items.personal, ...personal } : items.personal;
        const retriedWSList = Object.keys(retriedWS).length > 0
          ? { ...items.retriedWS, ...retriedWS } : items.retriedWS;
        const sharedWs = Object.keys(shareWs).length > 0
          ? { ...items.shareWs, ...shareWs } : items.shareWs;

        return {
          ...state,
          boardLeftmenuData: {
            ...state.boardLeftmenuData,
            myBoards: action.value.myBoards || state.boardLeftmenuData.myBoards,
            sharedBoards: action.value.sharedBoards || state.boardLeftmenuData.sharedBoards,
            workstreams: {
              ...state.boardLeftmenuData.workstreams,
              personal: Object.values(newPersonal).sort((a, b) => a.name.localeCompare(b.name)),
              retriedWS: Object.values(retriedWSList).sort((a, b) => a.name.localeCompare(b.name)),
              sharedWs: Object.values(sharedWs).sort((a, b) => a.name.localeCompare(b.name)),
              teams: Object.values(newTeams).sort((a, b) => a.name.localeCompare(b.name))
            }

          },
          totalCount: workstreamData.toalCount
        }
      }
      break;
    default:
      state = { ...state, initState };
      break;
  }
  return state;
};
export default FullBoardReducers;